import React, { Component } from 'react'
import { TextField, InputAdornment, Paper } from '@material-ui/core'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined'
import clsx from 'clsx'

export class Password extends Component {
  render() {
    return (
      <div style={{ display: 'inline-grid' }}>
        <TextField
          onChange={this.props.onChange}
          type="password"
          name="password"
          required
          label="Password"
          id="password"
          style={{
            margin: '6px'
          }}
          margin="dense"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <LockOutlinedIcon className="icon-color" />
              </InputAdornment>
            )
          }}
          className="text-field-style"
          variant="outlined"
          autoComplete="false"
        />
        <TextField
          onChange={this.props.onChange}
          style={{
            margin: '6px'
          }}
          type="password"
          required
          name="password_confirmation"
          label="Confirm Password"
          id="password_confirmation"
          value={this.props.password}
          defaultChecked={this.props.password}
          margin="dense"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <LockOutlinedIcon className="icon-color" />
              </InputAdornment>
            )
          }}
          className="text-field-style"
          variant="outlined"
          autoComplete="false"
        />
        <Paper
          style={{
            background: 'var(--trasparent)',
            margin: '6px',
            display: 'inline-grid'
          }}
          className={clsx('card-body-color', 'text-color')}>
          {this.props.formErrors.length > 0 && (
            <span
              style={{
                color: 'var(--red)',
                display: 'flex',
                margin: '0',
                padding: '0 6px',
                alignItems: 'center',
                border: '1px solid var(--red)',
                borderRadius: '5px'
              }}
              className="errorMessage">
              <ErrorOutlineOutlinedIcon fontSize="small" />
              {'  '}&nbsp;
              {this.props.formErrors}
            </span>
          )}
        </Paper>
      </div>
    )
  }
}
export default Password
